/**
 * BITE / ENTRY 브랜드 아이콘 — 인라인 SVG (currentColor).
 *
 * 부모의 color 속성을 따라가므로 흰색 background / 빨간 background / 남색 background
 * 어디서든 부모의 color: #FFF (또는 그 색) 만 지정하면 자동으로 그 색으로 노출.
 *
 * 사용처:
 *   - app-sidebar.tsx — 좌측 nav 항목 (물린 종목 진단 / 진입 시점 분석)
 *   - analyze-client.tsx — 좌측 hook 카드 헤더
 *   - 추후 BITE/ENTRY 페이지 hero, paywall, etc.
 */

interface IconProps {
  className?: string;
  size?: number;
}

export function BiteIcon({ className, size = 18 }: IconProps) {
  // BITE 송곳니 — PNG(흰색 alpha) 를 mask 로 쓰고 부모 color 로 fill.
  // 흰 배경/빨강 배경/회색 배경 어디서든 부모 color 만 지정하면 그 색으로 자동 노출.
  // (이전: <img> 직접 → currentColor 적용 불가 → 빨강 nav 외에는 강조 불가능했음)
  return (
    <span
      className={className}
      aria-hidden="true"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        backgroundColor: "currentColor",
        WebkitMaskImage: "url(/bite-logo-white.png)",
        maskImage: "url(/bite-logo-white.png)",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        flexShrink: 0,
      }}
    />
  );
}

export function EntryIcon({ className, size = 18 }: IconProps) {
  // ENTRY 아치 로고 — 사용자 제공 (entry_logo_arch_n.svg).
  // viewBox 를 path 영역 (130~382) 에 맞춰 tight crop.
  // CRITICAL: width/height 를 inline style 로 강제 — className 의 Tailwind w-4/h-4
  //   같은 CSS 클래스는 SVG width attribute 를 override 해버리니까 inline 으로 못박음.
  return (
    <svg
      className={className}
      viewBox="120 130 272 272"
      fill="currentColor"
      style={{ display: "block", width: size, height: size }}
      aria-hidden="true"
    >
      <path d="M 130 392 L 130 220 Q 130 140 220 140 L 382 140 L 382 392 L 296 392 L 296 280 Q 296 232 256 232 Q 216 232 216 280 L 216 392 Z" />
    </svg>
  );
}
